(function () {
  "use strict";

  function revealImmediately(items) {
    items.forEach(function (el) {
      el.classList.add("is-visible");
      el.setAttribute("data-aw-reveal-bound", "true");
    });
  }

  function initAwScrollReveal(root) {
    root = root || document;
    var items = Array.prototype.slice.call(root.querySelectorAll("[data-aw-reveal]:not([data-aw-reveal-bound])"));
    if (!items.length) return;

    if (!("IntersectionObserver" in window) || document.documentElement.classList.contains("no-js")) {
      revealImmediately(items);
      return;
    }

    var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduceMotion) {
      revealImmediately(items);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var delay = parseInt(el.getAttribute("data-aw-reveal-delay") || "0", 10);
          if (delay > 0) {
            setTimeout(function () {
              el.classList.add("is-visible");
            }, delay);
          } else {
            el.classList.add("is-visible");
          }
          obs.unobserve(el);
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -10% 0px" }
    );

    items.forEach(function (el) {
      el.setAttribute("data-aw-reveal-bound", "true");
      observer.observe(el);
    });
  }

  /* Measures the theme's fixed sticky Add-to-Cart bar (if present on this
     page) so sticky elements like the comfort-features media column can
     reserve space for it and never get visually covered by it. The bar
     stays in the DOM at its full height even while translated off-screen,
     so this works whether or not it's currently visible. */
  function updateAtcBarHeight() {
    var bar = document.querySelector(".m-sticky-addtocart");
    var height = bar ? bar.offsetHeight : 0;
    document.documentElement.style.setProperty("--aw-atc-bar-h", height + "px");
  }

  var resizeTimer = null;
  function scheduleAtcBarUpdate() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateAtcBarHeight, 150);
  }

  document.addEventListener("DOMContentLoaded", function () {
    initAwScrollReveal(document);
    updateAtcBarHeight();
    window.addEventListener("resize", scheduleAtcBarUpdate, { passive: true });
  });

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener("shopify:section:load", function (e) {
      initAwScrollReveal(e.target);
      updateAtcBarHeight();
    });
  }
})();
